import { createZodDto } from "nestjs-zod/dto";
import z from "zod";
import { Prisma } from "@prisma/client";

const jsonSchema = z.custom<Prisma.InputJsonValue>();
const createScoreSuggestionSchema = z.object({
  resumeId: z.string().min(1),
  jobDescriptionHash: z.string().min(1),
  jobDescription: z.string().min(1),
  resumeSnapshot: jsonSchema,
  atsScore: z.number(),
  skillsMatchPercentage: z.number().nullable().optional(),
  experienceRelevance: z.number().nullable().optional(),
  requirementsAnalysis: jsonSchema,
  scoreAdjustments: jsonSchema,
  matchingKeywords: jsonSchema,
  missingKeywords: jsonSchema,
  improvementSuggestions: jsonSchema,
  summary: z.string(),
  previousSuggestionId: z.string().nullable().optional(),
});

export class CreateScoreSuggestionDto extends createZodDto(createScoreSuggestionSchema) {}
